class NavigationBarItem {
    constructor(element) {
        this.item = element
        this.state = 'closed'

        this.init()
    }

    get titleElement() {
        return this.item.querySelector('span')
    }

    get buttonElement() {
        return this.item.querySelector('button')
    }

    get subNav() {
        return this.item.querySelector('[data-subnav]')
    }

    get isOpened() {
        return this.state === 'opened'
    }

    get isClosed() {
        return this.state === 'closed'
    }

    open() {
        this.state = 'opened'
        this.item.classList.add('is-expanded')
        this.buttonElement.setAttribute('aria-expanded', 'true')
    }

    close() {
        this.state = 'closed'
        this.item.classList.remove('is-expanded')
        this.buttonElement.setAttribute('aria-expanded', 'false')
    }

    init() {
        this.bindClickEvents()
        this.bindFocusEvents()
        this.bindKeyboardEvents()
        this.bindMouseEvents()
    }

    bindClickEvents() {
        this.buttonElement.addEventListener('click', () => this.isOpened ? this.close() : this.open())
    }

    bindFocusEvents() {
        this.subNav.addEventListener('focusout', this.handleFocusOut.bind(this))
    }

    bindKeyboardEvents() {
        this.subNav.addEventListener('keydown', (event) => {
            if (this.isOpened && event.key === 'Escape') {
                this.close()
                this.buttonElement.focus()
            }
        })
    }

    bindMouseEvents() {
        this.item.addEventListener('mouseenter', this.open.bind(this))
        this.item.addEventListener('mouseleave', this.close.bind(this))
    }

    handleFocusOut(event) {
        if (this.isOpened && !this.item.contains(event.relatedTarget)) {
            this.close()
        }
    }
}

export default NavigationBarItem
